"use client"

import { useEffect, useState } from "react"
import axios from "axios"
import "../styles/CircuitosAdmin.css"

const CircuitosAdmin = () => {
  const [circuitos, setCircuitos] = useState([])
  const [editandoCircuito, setEditandoCircuito] = useState(null)
  
  // 💡 NOVO: Estado para gerenciar as categorias com preços E DESCRIÇÃO
  const [categoriasList, setCategoriasList] = useState([{ nome: "", descricao: "", valor: 0, valorCavalo: 0, valorCavaloLote2: 0, valorCavaloAvulso: 0, valorLote2: 0, dataViradaLote: "" }])

  const [novoCircuito, setNovoCircuito] = useState({
    nome: "",
    slug: "",
    descricao: "",
    corPrimaria: "#d4af37",
    corSecundaria: "#111111",
    bgPrimario: "#0f0f0f",
    bgSecundario: "#171717",
    textoPrimario: "#ffffff",
    botaoTexto: "#000000",
    taxaInscricao: 0,
    regulamentoHtml: "",
    imagem: null,
  })

  const gerarSlug = (texto) => {
    return texto
      .toLowerCase()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .replace(/[^a-z0-9 ]/g, "")
      .trim()
      .replace(/\s+/g, "-")
  }

  const [previewImage, setPreviewImage] = useState(null)

  const [participante, setParticipante] = useState({
    nome: "", tipo: "vaqueiro", categoria: "", pontos: 0, etapas: 0,
    vaquejadas: 0, classificacoes: 0, bateuSenha: 0, rachas: 0,
  })

  const [circuitoSelecionado, setCircuitoSelecionado] = useState(null)
  const [categoriaSelecionada, setCategoriaSelecionada] = useState("")
  const [participantesFiltrados, setParticipantesFiltrados] = useState([])
  const [modalAberto, setModalAberto] = useState(false)
  const [editandoParticipante, setEditandoParticipante] = useState(null)
  const [loading, setLoading] = useState(false)

  const fetchCircuitos = async () => {
    setLoading(true)
    try {
      const res = await axios.get("https://api.ticketdovaqueiro.com/api/circuitos")
      setCircuitos(res.data)
    } catch (error) {
      console.error("Erro ao carregar circuitos:", error)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    fetchCircuitos()
  }, [])

  const handleImageChange = (e) => {
    const file = e.target.files[0]
    if (file) {
      setNovoCircuito({ ...novoCircuito, imagem: file })
      const reader = new FileReader()
      reader.onloadend = () => { setPreviewImage(reader.result) }
      reader.readAsDataURL(file)
    }
  }

  const criarCircuito = async () => {
    try {
      setLoading(true)
      if (!novoCircuito.nome.trim()) return alert("Informe o nome do circuito")
      if (!novoCircuito.slug.trim()) return alert("Informe o slug do circuito")

      const formData = new FormData()
      formData.append("nome", novoCircuito.nome)
      formData.append("slug", novoCircuito.slug)
      formData.append("descricao", novoCircuito.descricao)
      formData.append("corPrimaria", novoCircuito.corPrimaria)
      formData.append("corSecundaria", novoCircuito.corSecundaria)
      formData.append("bgPrimario", novoCircuito.bgPrimario)
      formData.append("bgSecundario", novoCircuito.bgSecundario)
      formData.append("textoPrimario", novoCircuito.textoPrimario)
      formData.append("botaoTexto", novoCircuito.botaoTexto)
      formData.append("taxaInscricao", novoCircuito.taxaInscricao)
      formData.append("regulamentoHtml", novoCircuito.regulamentoHtml)

      const categoriasValidas = categoriasList.filter(c => c.nome.trim() !== "");
      formData.append("categorias", JSON.stringify(categoriasValidas))

      if (novoCircuito.imagem) formData.append("imagem", novoCircuito.imagem)

      await axios.post("https://api.ticketdovaqueiro.com/api/circuitos/create", formData)

      setNovoCircuito({
        nome: "", slug: "", descricao: "", corPrimaria: "#d4af37", corSecundaria: "#111111",
        taxaInscricao: 0, regulamentoHtml: "", imagem: null,
      })
      setCategoriasList([{ nome: "", descricao: "", valor: 0, valorCavalo: 0, valorCavaloLote2: 0, valorCavaloAvulso: 0, valorLote2: 0, dataViradaLote: "" }])
      setPreviewImage(null)
      fetchCircuitos()
    } catch (err) {
      alert(err?.response?.data?.erro || "Erro ao criar circuito")
    } finally {
      setLoading(false)
    }
  }

  const carregarCircuitoParaEdicao = async (id) => {
    const res = await axios.get(`https://api.ticketdovaqueiro.com/api/circuitos/${id}`)
    const c = res.data

    setNovoCircuito({
      nome: c.nome, slug: c.slug, descricao: c.descricao, corPrimaria: c.corPrimaria,
      corSecundaria: c.corSecundaria, bgPrimario: c.bgPrimario, bgSecundario: c.bgSecundario,
      textoPrimario: c.textoPrimario, botaoTexto: c.botaoTexto, taxaInscricao: c.taxaInscricao,
      regulamentoHtml: c.regulamentoHtml, imagem: null,
    })

    // 💡 Carrega as categorias incluindo a Descrição
    if (c.categorias && c.categorias.length > 0) {
      setCategoriasList(c.categorias.map(cat => {
        if (typeof cat === 'string') return { nome: cat, descricao: "", valor: c.taxaInscricao || 0, valorCavalo: 0, valorCavaloLote2: 0, valorCavaloAvulso: 0, valorLote2: 0, dataViradaLote: "" };
        return { 
          nome: cat.nome || "", 
          descricao: cat.descricao || "", // 👈 NOVO
          valor: cat.valor || 0, 
          valorCavalo: cat.valorCavalo || 0,
          valorCavaloLote2: cat.valorCavaloLote2 || 0,
          valorCavaloAvulso: cat.valorCavaloAvulso || 0,
          valorLote2: cat.valorLote2 || 0,
          dataViradaLote: cat.dataViradaLote || ""
        };
      }));
    } else {
      setCategoriasList([{ nome: "", descricao: "", valor: 0, valorCavalo: 0, valorCavaloLote2: 0, valorCavaloAvulso: 0, valorLote2: 0, dataViradaLote: "" }]);
    }

    setPreviewImage(c.imagem ? `https://api.ticketdovaqueiro.com/uploads/${c.imagem}` : null)
    setEditandoCircuito(c._id)
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  const atualizarCircuito = async () => {
    const formData = new FormData()

    Object.entries(novoCircuito).forEach(([key, value]) => {
      if (value !== null) formData.append(key, value)
    })

    const categoriasValidas = categoriasList.filter(c => c.nome.trim() !== "");
    formData.append("categorias", JSON.stringify(categoriasValidas))

    await axios.put(`https://api.ticketdovaqueiro.com/api/circuitos/${editandoCircuito}`, formData)

    setEditandoCircuito(null)
    setPreviewImage(null)
    fetchCircuitos()
  }

  const selecionarCircuito = async (id) => {
    setLoading(true)
    try {
      setCircuitoSelecionado(id)
      const res = await axios.get(`https://api.ticketdovaqueiro.com/api/circuitos/${id}`)
      const circuito = res.data
      if (circuito.categorias.length > 0) {
        const primeiraCat = circuito.categorias[0];
        setCategoriaSelecionada(typeof primeiraCat === 'string' ? primeiraCat : primeiraCat.nome);
      }
      setParticipantesFiltrados(circuito.participantes)
    } catch (error) {
      console.error("Erro ao selecionar circuito:", error)
    } finally {
      setLoading(false)
    }
  }

  const abrirModalParticipante = (p = null) => {
    setEditandoParticipante(p)
    setParticipante(
      p || {
        nome: "", tipo: "vaqueiro", categoria: categoriaSelecionada,
        pontos: 0, etapas: 0, vaquejadas: 0, classificacoes: 0, bateuSenha: 0, rachas: 0,
      },
    )
    setModalAberto(true)
  }

  const adicionarParticipante = async () => {
    try {
      setLoading(true)
      await axios.put(`https://api.ticketdovaqueiro.com/api/circuitos/${circuitoSelecionado}/add-participante`, participante)
      setModalAberto(false)
      setEditandoParticipante(null)
      selecionarCircuito(circuitoSelecionado)
    } catch (err) {
      console.error("Erro ao adicionar participante:", err)
    } finally {
      setLoading(false)
    }
  }

  const atualizarParticipante = async () => {
    try {
      setLoading(true)
      await axios.put(`https://api.ticketdovaqueiro.com/api/circuitos/${circuitoSelecionado}/update-participante`, {
        ...participante,
        idParticipante: editandoParticipante._id,
      })
      setModalAberto(false)
      setEditandoParticipante(null)
      selecionarCircuito(circuitoSelecionado)
    } catch (err) {
      console.error("Erro ao atualizar participante:", err)
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="pro-admin-circuitos-page">
      <div className="pro-admin-circuitos-container">
        <div className="pro-admin-circuitos-header">
          <div className="pro-admin-title-container">
            <svg className="pro-admin-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M12 6V2M12 6C8.68629 6 6 8.68629 6 12C6 15.3137 8.68629 18 12 18C15.3137 18 18 15.3137 18 12C18 8.68629 15.3137 6 12 6ZM17 4L19 2M7 4L5 2M12 18V22M17 20L19 22M7 20L5 22" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
            <h1 className="pro-admin-title">Gerenciar Circuitos</h1>
          </div>
          <p className="pro-admin-subtitle">Crie e gerencie circuitos e participantes do sistema de ranking</p>
        </div>

        <div className="pro-admin-circuitos-create">
          <h2 className="pro-section-title">
            <svg className="pro-section-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M12 5V19M5 12H19" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
            {editandoCircuito ? "Editar Circuito" : "Criar novo circuito"}
          </h2>

          <div className="pro-create-form-grid">
            <div className="pro-form-fields">
              <div className="pro-form-group">
                <label className="pro-form-label">Nome do circuito</label>
                <input
                  type="text"
                  placeholder="Ex: Circuito Nordeste 2024"
                  value={novoCircuito.nome}
                  onChange={(e) => {
                    const nomeDigitado = e.target.value
                    setNovoCircuito((prev) => ({
                      ...prev,
                      nome: nomeDigitado,
                      slug: prev.slug ? prev.slug : gerarSlug(nomeDigitado),
                    }))
                  }}
                  className="pro-form-input"
                />
              </div>
              <div className="pro-form-group">
                <label className="pro-form-label">Slug (URL do circuito)</label>
                <input
                  type="text"
                  placeholder="Ex: circuito-nordeste-2024"
                  value={novoCircuito.slug}
                  onChange={(e) => setNovoCircuito({ ...novoCircuito, slug: e.target.value })}
                  className="pro-form-input"
                />
              </div>
              <div className="pro-form-group">
                <label className="pro-form-label">Descrição do circuito</label>
                <textarea
                  placeholder="Texto curto para aparecer na página..."
                  value={novoCircuito.descricao}
                  onChange={(e) => setNovoCircuito({ ...novoCircuito, descricao: e.target.value })}
                  className="pro-form-input"
                  rows={3}
                />
              </div>

              <div className="pro-form-group">
                <label className="pro-form-label">Cores do circuito</label>
                <div style={{ display: "flex", gap: 10 }}>
                  <div style={{ flex: 1 }}>
                    <small>Primária</small>
                    <input type="color" value={novoCircuito.corPrimaria} onChange={(e) => setNovoCircuito({ ...novoCircuito, corPrimaria: e.target.value })} className="pro-form-input" style={{ height: 45, padding: 0 }} />
                  </div>
                  <div style={{ flex: 1 }}>
                    <small>Secundária</small>
                    <input type="color" value={novoCircuito.corSecundaria} onChange={(e) => setNovoCircuito({ ...novoCircuito, corSecundaria: e.target.value })} className="pro-form-input" style={{ height: 45, padding: 0 }} />
                  </div>
                </div>
              </div>

              <div className="pro-form-group">
                <label className="pro-form-label">Regulamento (HTML ou texto)</label>
                <textarea
                  placeholder="<h2>Regulamento</h2>..."
                  value={novoCircuito.regulamentoHtml}
                  onChange={(e) => setNovoCircuito({ ...novoCircuito, regulamentoHtml: e.target.value })}
                  className="pro-form-input"
                  rows={6}
                />
              </div>

              {/* 💡 BLOCO DINÂMICO DE CATEGORIAS ATUALIZADO */}
              <div className="pro-form-group" style={{ gridColumn: "1 / -1" }}>
                <label className="pro-form-label">Categorias, Preços e Descrições</label>
                
                {categoriasList.map((cat, idx) => (
                  <div key={idx} style={{ background: "rgba(255,255,255,0.02)", padding: 16, borderRadius: 12, marginBottom: 16, border: "1px solid rgba(255,255,255,0.05)" }}>
                    
                    {/* Linha 1: Nome e Descrição */}
                    <div style={{ display: "flex", gap: 10, marginBottom: 12 }}>
                      <div style={{ flex: 1 }}>
                        <small style={{ color: "rgba(255,255,255,0.6)" }}>Nome da Categoria *</small>
                        <input type="text" placeholder="Ex: Profissional" value={cat.nome} onChange={(e) => { const n = [...categoriasList]; n[idx].nome = e.target.value; setCategoriasList(n); }} className="pro-form-input" style={{ marginBottom: 0 }} />
                      </div>
                      <div style={{ flex: 2 }}>
                        <small style={{ color: "rgba(255,255,255,0.6)" }}>Descrição Opcional (Exibida na tela de Associação)</small>
                        <input type="text" placeholder="Ex: Destinada a vaqueiros com mais de 10 pontos..." value={cat.descricao} onChange={(e) => { const n = [...categoriasList]; n[idx].descricao = e.target.value; setCategoriasList(n); }} className="pro-form-input" style={{ marginBottom: 0 }} />
                      </div>
                    </div>

                    {/* Linha 2: Valores e Lotes */}
                    <div style={{ display: "flex", gap: 10, alignItems: "flex-end" }}>
                      <div style={{ flex: 1 }}>
                        <small style={{ color: "var(--c-accent)" }}>R$ Inscrição (1º Lote)</small>
                        <input type="number" placeholder="0" value={cat.valor} onChange={(e) => { const n = [...categoriasList]; n[idx].valor = Number(e.target.value); setCategoriasList(n); }} className="pro-form-input" style={{ marginBottom: 0 }} />
                      </div>
                      <div style={{ flex: 1 }}>
                        <small style={{ color: "rgba(255,255,255,0.6)" }}>R$ Extra do Cavalo (1º Lote)</small>
                        <input type="number" placeholder="0" value={cat.valorCavalo} onChange={(e) => { const n = [...categoriasList]; n[idx].valorCavalo = Number(e.target.value); setCategoriasList(n); }} className="pro-form-input" style={{ marginBottom: 0 }} />
                      </div>
                      <div style={{ flex: 1 }}>
                        <small style={{ color: "rgba(255,255,255,0.6)" }}>R$ Extra do Cavalo (2º Lote)</small>
                        <input type="number" placeholder="0" value={cat.valorCavaloLote2 || 0} onChange={(e) => { const n = [...categoriasList]; n[idx].valorCavaloLote2 = Number(e.target.value); setCategoriasList(n); }} className="pro-form-input" style={{ marginBottom: 0 }} />
                      </div>
                      <div style={{ flex: 1 }}>
                        <small style={{ color: "#f59e0b" }}>R$ Cavalo Avulso (sem vaqueiro)</small>
                        <input type="number" placeholder="0" value={cat.valorCavaloAvulso} onChange={(e) => { const n = [...categoriasList]; n[idx].valorCavaloAvulso = Number(e.target.value); setCategoriasList(n); }} className="pro-form-input" style={{ marginBottom: 0 }} />
                      </div>
                      <div style={{ flex: 1 }}>
                        <small style={{ color: "rgba(255,255,255,0.6)" }}>Data Virada de Lote</small>
                        <input type="datetime-local" value={cat.dataViradaLote} onChange={(e) => { const n = [...categoriasList]; n[idx].dataViradaLote = e.target.value; setCategoriasList(n); }} className="pro-form-input" style={{ marginBottom: 0 }} />
                      </div>
                      <div style={{ flex: 1 }}>
                        <small style={{ color: "rgba(255,255,255,0.6)" }}>R$ 2º Lote</small>
                        <input type="number" placeholder="0" value={cat.valorLote2} onChange={(e) => { const n = [...categoriasList]; n[idx].valorLote2 = Number(e.target.value); setCategoriasList(n); }} className="pro-form-input" style={{ marginBottom: 0 }} />
                      </div>
                      <button type="button" onClick={() => setCategoriasList(categoriasList.filter((_, i) => i !== idx))} style={{ background: "rgba(239, 68, 68, 0.2)", color: "#ef4444", border: "1px solid rgba(239, 68, 68, 0.3)", padding: "12px", borderRadius: "8px", cursor: "pointer", height: "44px" }}>
                        X
                      </button>
                    </div>

                  </div>
                ))}

                <button 
                  type="button" 
                  onClick={() => setCategoriasList([...categoriasList, { nome: "", descricao: "", valor: 0, valorCavalo: 0, valorCavaloLote2: 0, valorCavaloAvulso: 0, valorLote2: 0, dataViradaLote: "" }])}
                  style={{ background: "rgba(212, 175, 55, 0.1)", color: "#d4af37", border: "1px dashed rgba(212, 175, 55, 0.4)", padding: "12px 16px", borderRadius: "8px", cursor: "pointer", fontWeight: "bold", width: "100%", transition: "all 0.2s" }}
                >
                  + Adicionar Nova Categoria
                </button>
              </div>

              <div className="pro-form-group">
                <label className="pro-form-label">Imagem do circuito</label>
                <div className="pro-file-input-container">
                  <label className="pro-file-input-label">
                    Selecionar imagem
                    <input type="file" className="pro-file-input" onChange={handleImageChange} />
                  </label>
                  {novoCircuito.imagem && <span className="pro-file-name">{novoCircuito.imagem.name}</span>}
                </div>
              </div>
            </div>

            <div className="pro-image-preview-container">
              {previewImage ? (
                <div className="pro-image-preview-wrapper">
                  <img src={previewImage} alt="Preview" className="pro-image-preview" />
                  <button onClick={() => { setPreviewImage(null); setNovoCircuito({ ...novoCircuito, imagem: null }) }} className="pro-remove-image-btn">
                    X
                  </button>
                </div>
              ) : (
                <div className="pro-empty-preview"><p>Prévia da imagem</p></div>
              )}
            </div>
          </div>

          <div className="pro-form-actions">
            <button onClick={editandoCircuito ? atualizarCircuito : criarCircuito} disabled={loading} className="pro-create-btn">
              {loading ? "Processando..." : (editandoCircuito ? "Salvar Alterações" : "Criar Circuito")}
            </button>
            {editandoCircuito && (
              <button onClick={() => {
                setEditandoCircuito(null); 
                setNovoCircuito({ nome: "", slug: "", descricao: "", corPrimaria: "#d4af37", corSecundaria: "#111111", taxaInscricao: 0, regulamentoHtml: "", imagem: null });
                setCategoriasList([{ nome: "", descricao: "", valor: 0, valorCavalo: 0, valorCavaloLote2: 0, valorCavaloAvulso: 0, valorLote2: 0, dataViradaLote: "" }]);
                setPreviewImage(null);
              }} className="pro-cancel-btn" style={{ marginLeft: 16 }}>
                Cancelar Edição
              </button>
            )}
          </div>
        </div>

        {/* Lista de Circuitos */}
        <div className="pro-admin-circuitos-list">
          <h2 className="pro-section-title">Circuitos existentes</h2>
          {loading && circuitos.length === 0 ? (
            <div className="pro-loading-container"><div className="pro-loading-spinner"></div></div>
          ) : circuitos.length > 0 ? (
            <div className="pro-circuitos-grid">
              {circuitos.map((c) => (
                <div key={c._id} className={`pro-circuito-card ${circuitoSelecionado === c._id ? "pro-selected" : ""}`}>
                  <div className="pro-circuito-image-container">
                    {c.imagem && <img src={`https://api.ticketdovaqueiro.com/uploads/${c.imagem}`} alt={c.nome} className="pro-circuito-image" />}
                  </div>
                  <div className="pro-circuito-details">
                    <h3 className="pro-circuito-name">{c.nome}</h3>
                    <p className="pro-circuito-categories">
                      {c.categorias.map(cat => typeof cat === 'string' ? cat : cat.nome).join(", ")}
                    </p>
                    <button onClick={() => selecionarCircuito(c._id)} className={`pro-select-circuito-btn ${circuitoSelecionado === c._id ? "pro-selected" : ""}`}>
                      {circuitoSelecionado === c._id ? "Selecionado" : "Selecionar"}
                    </button>
                    <button onClick={() => carregarCircuitoParaEdicao(c._id)} className="pro-edit-btn" style={{ marginLeft: 8 }}>Editar</button>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <p className="pro-empty-message">Nenhum circuito encontrado.</p>
          )}
        </div>

        {/* Participantes */}
        {circuitoSelecionado && (
          <div className="pro-admin-circuitos-participants">
            <div className="pro-participants-header">
              <h2 className="pro-section-title">Participantes</h2>
              <div className="pro-participants-filters">
                <div className="pro-filter-group">
                  <select value={categoriaSelecionada} onChange={(e) => setCategoriaSelecionada(e.target.value)} className="pro-category-select">
                    {circuitos.find((c) => c._id === circuitoSelecionado)?.categorias.map((cat, i) => {
                      const nomeCat = typeof cat === 'string' ? cat : cat.nome;
                      return <option key={i} value={nomeCat}>{nomeCat}</option>;
                    })}
                  </select>
                </div>
                <button onClick={() => abrirModalParticipante(null)} className="pro-add-participant-btn">
                  Adicionar Participante
                </button>
              </div>
            </div>

            {loading ? (
              <div className="pro-loading-container"><div className="pro-loading-spinner"></div></div>
            ) : participantesFiltrados.filter((p) => p.categoria === categoriaSelecionada).length > 0 ? (
              <div className="pro-participants-table-container">
                <table className="pro-participants-table">
                  <thead>
                    <tr><th>Nome</th><th>Tipo</th><th>P</th><th>E</th><th>V</th><th>C</th><th>B</th><th>R</th><th>Ações</th></tr>
                  </thead>
                  <tbody>
                    {participantesFiltrados.filter((p) => p.categoria === categoriaSelecionada).map((p, i) => (
                      <tr key={i} className="pro-participant-row">
                        <td className="pro-name-cell">{p.nome}</td>
                        <td className="pro-type-cell">{p.tipo}</td>
                        <td className="pro-points-cell">{p.pontos}</td>
                        <td className="pro-stat-cell">{p.etapas}</td>
                        <td className="pro-stat-cell">{p.vaquejadas}</td>
                        <td className="pro-stat-cell">{p.classificacoes}</td>
                        <td className="pro-stat-cell">{p.bateuSenha}</td>
                        <td className="pro-stat-cell">{p.rachas}</td>
                        <td className="pro-actions-cell">
                          <button onClick={() => abrirModalParticipante(p)} className="pro-edit-btn">Editar</button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            ) : (
              <div className="pro-empty-participants">
                <h3 className="pro-empty-title">Nenhum participante encontrado</h3>
              </div>
            )}
          </div>
        )}

        {/* Modal Participante */}
        {modalAberto && (
          <div className="pro-modal-overlay">
            <div className="pro-modal-container">
              <div className="pro-modal-header">
                <h3 className="pro-modal-title">{editandoParticipante ? "Editar Participante" : "Novo Participante"}</h3>
                <button onClick={() => { setModalAberto(false); setEditandoParticipante(null) }} className="pro-modal-close-btn">X</button>
              </div>
              <div className="pro-modal-content">
                <div className="pro-modal-form">
                  <div className="pro-form-group">
                    <label className="pro-form-label">Nome</label>
                    <input type="text" value={participante.nome} onChange={(e) => setParticipante({ ...participante, nome: e.target.value })} className="pro-form-input" />
                  </div>
                  <div className="pro-form-group">
                    <label className="pro-form-label">Tipo</label>
                    <select value={participante.tipo} onChange={(e) => setParticipante({ ...participante, tipo: e.target.value })} className="pro-form-select">
                      <option value="vaqueiro">Vaqueiro</option>
                      <option value="esteireiro">Esteireiro</option>
                      <option value="cavaloPuxada">Cavalo de Puxada</option>
                      <option value="cavaloEsteira">Cavalo de Esteira</option>
                    </select>
                  </div>
                  <div className="pro-form-row">
                    <div className="pro-form-group pro-half"><label className="pro-form-label">Pontos</label><input type="number" value={participante.pontos} onChange={(e) => setParticipante({ ...participante, pontos: Number(e.target.value) })} className="pro-form-input" /></div>
                    <div className="pro-form-group pro-half"><label className="pro-form-label">Etapas</label><input type="number" value={participante.etapas} onChange={(e) => setParticipante({ ...participante, etapas: Number(e.target.value) })} className="pro-form-input" /></div>
                  </div>
                  <div className="pro-form-row">
                    <div className="pro-form-group pro-half"><label className="pro-form-label">Vaquejadas</label><input type="number" value={participante.vaquejadas} onChange={(e) => setParticipante({ ...participante, vaquejadas: Number(e.target.value) })} className="pro-form-input" /></div>
                    <div className="pro-form-group pro-half"><label className="pro-form-label">Classificações</label><input type="number" value={participante.classificacoes} onChange={(e) => setParticipante({ ...participante, classificacoes: Number(e.target.value) })} className="pro-form-input" /></div>
                  </div>
                  <div className="pro-form-row">
                    <div className="pro-form-group pro-half"><label className="pro-form-label">Bateu Senha</label><input type="number" value={participante.bateuSenha} onChange={(e) => setParticipante({ ...participante, bateuSenha: Number(e.target.value) })} className="pro-form-input" /></div>
                    <div className="pro-form-group pro-half"><label className="pro-form-label">Rachas</label><input type="number" value={participante.rachas} onChange={(e) => setParticipante({ ...participante, rachas: Number(e.target.value) })} className="pro-form-input" /></div>
                  </div>
                </div>
              </div>
              <div className="pro-modal-footer">
                <button type="button" onClick={editandoParticipante ? atualizarParticipante : adicionarParticipante} className="pro-save-btn">{editandoParticipante ? "Atualizar" : "Adicionar"}</button>
                <button type="button" onClick={() => { setModalAberto(false); setEditandoParticipante(null) }} className="pro-cancel-btn">Cancelar</button>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  )
}

export default CircuitosAdmin